import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { RepresentativeService } from '../services/representative.service';
import { Representative } from '../models/representative';

interface IState {
  representatives: Representative[];
  status: string;
  columns: any;
}

export class RepresentativesPage extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      representatives: new Array<Representative>(),
      status: "",
      columns: [{
        dataField: 'id',
        text: 'ID',
        headerStyle: () => {
          return { width: '5%' };
        },
        sort: true
      },
      {
        dataField: 'profilePhotoUrl',
        text: 'Slika',
        formatter: (cellContent, row) => {
          return (
            <Image src={row.profilePhotoUrl} />
          );
        },
        headerStyle: () => {
          return { width: '13%' };
        }
      },
      {
        dataField: 'firstName',
        text: 'Ime',
        sort: true,
        filter: textFilter(),
        headerStyle: () => {
          return { width: '13%' };
        }
      }, 
      {
        dataField: 'lastName',
        text: 'Prezime',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'email',
        text: 'Email',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'phone',
        text: 'Telefon',
        sort: true,
        filter: textFilter()
      },
      {
        dataField: 'edit',
        isDummyField: true,
        text: 'Uredi',
        formatter: (cellContent, row) => {
          return (
            <LinkContainer to={'/representative/edit/' + row.id}>
              <Button className="btn-primary">
                Uredi
              </Button>
            </LinkContainer>
          );
        },
        headerStyle: () => {
          return { width: '10%' };
        }
      }]
    };
  }

  componentDidMount() {
    RepresentativeService.getAll()
      .then(
        response => {
          this.setState({
            representatives: response
          });
        },
        error => {
          this.setState({
            status: error.message
          });
        }
      );
  }
  
  render() {
    return (
      <div>
        <h1 className="page-title">Zastupnici</h1>
        <div className="row form-group">
          <div className="col-md-12">
              <LinkContainer to={'/representative/edit'}>
                <Button className="btn-primary">
                  Unesi novog zastupnika
                </Button>
              </LinkContainer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            { this.state.status &&
              <div className={'alert alert-danger'}>{this.state.status}</div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <BootstrapTable 
              striped
              hover
              keyField='id' 
              data={ this.state.representatives } 
              columns={ this.state.columns }
              filter={ filterFactory() } 
              pagination={ paginationFactory() }/>
          </div>
        </div>
      </div>
    );
  }
}